import { appStorage } from './betaStorage'
export type CredentialType =
  | 'service_agreement'
  | 'drivers_licence'
  | 'wwcc'
  | 'ndis_screening'
  | 'car_insurance'
  | 'business_insurance'
  | 'qualification'
  | 'first_aid'
  | 'cpr'
  | 'abn'

export interface WorkerCredential {
  id: string
  userId: string
  type: CredentialType
  label: string
  referenceNumber?: string
  fileName?: string
  uploadedAt?: string
  expiryDate?: string
  privacyChecked: boolean
  reviewedAt?: string
  reviewedByUserId?: string
}

export const CREDENTIAL_TYPES: { type: CredentialType; label: string; numberOnly?: boolean; expiry?: boolean }[] = [
  { type: 'service_agreement', label: 'Service Agreement' },
  { type: 'drivers_licence', label: "Driver's Licence", expiry: true },
  { type: 'wwcc', label: "Working With Children's Check", expiry: true },
  { type: 'ndis_screening', label: 'NDIS Worker Screening', numberOnly: true, expiry: true },
  { type: 'car_insurance', label: 'Car Insurance', expiry: true },
  { type: 'business_insurance', label: 'Business Insurance', expiry: true },
  { type: 'qualification', label: 'Qualification' },
  { type: 'first_aid', label: 'First Aid', expiry: true },
  { type: 'cpr', label: 'CPR', expiry: true },
  { type: 'abn', label: 'ABN', numberOnly: true },
]

const STORAGE_KEY = 'schub.credentials.v1'

export function loadCredentials(): WorkerCredential[] {
  try {
    const raw = appStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : []
  } catch {
    return []
  }
}

export function credentialsForWorker(userId: string): WorkerCredential[] {
  return loadCredentials().filter((item) => item.userId === userId)
}

export function saveCredential(credential: WorkerCredential): void {
  const existing = loadCredentials().filter((item) => item.id !== credential.id)
  appStorage.setItem(STORAGE_KEY, JSON.stringify([...existing, credential]))
  window.dispatchEvent(new Event('schub-credentials-updated'))
}

export function reviewCredential(id: string, reviewerId: string): void {
  const next = loadCredentials().map((item) =>
    item.id === id
      ? { ...item, reviewedAt: new Date().toISOString(), reviewedByUserId: reviewerId }
      : item,
  )
  appStorage.setItem(STORAGE_KEY, JSON.stringify(next))
  window.dispatchEvent(new Event('schub-credentials-updated'))
}

export function credentialStatus(item: WorkerCredential): 'Missing' | 'Uploaded' | 'Expiring soon' | 'Expired' {
  if (!item.fileName && !item.referenceNumber) return 'Missing'
  if (!item.expiryDate) return 'Uploaded'
  const today = new Date()
  const expiry = new Date(`${item.expiryDate}T23:59:59`)
  if (expiry < today) return 'Expired'
  const days = Math.ceil((expiry.getTime() - today.getTime()) / 86400000)
  return days <= 60 ? 'Expiring soon' : 'Uploaded'
}

